import React, { useEffect } from "react";
import { Dialog, DialogTitle, DialogContent, DialogContentText, TextField, DialogActions, Button, TableCell, TableRow, Checkbox, FormControl, InputLabel, ListItemText, MenuItem, OutlinedInput, Select, Stack, Skeleton, Autocomplete } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import axios from "axios";
import { title } from "process";
import { CacheService } from "../../common/services/cache.service";
import environment from "../../environment/environment";
import APIService from "../../services/api.service";
import { User } from "../../models/user";

export function UpdateAssignedTicDialog({ticData, users, handleSaveClick, handleCloseClick}: {ticData: any, users: User[], handleSaveClick: any, handleCloseClick: any}) {
  const [open, setOpen] = React.useState(true); 
  const [form, setForm] = React.useState<any>({});
  console.log('users', users);
  console.log('ticData', ticData);

  const handleChange = (value: any) => {
    setForm({['user']: value});
    setForm({['requestor']: value.userId});
    console.log('value', value);
  };

  const optionLabel = (lastName: string, firstName: string, userName: string) => { 
    let label = lastName + ', ' + firstName;
    if(label == ', ') { 
      label = userName;
    }

    return label;
  }
  return (
    <div>
      <Dialog open={open}  PaperProps={{ style: { minWidth: "900px" } }}>
        <DialogTitle sx={{ fontWeight: "bolder" }}>Edit</DialogTitle>
        <DialogContent>
          <DialogContentText sx={{ color: "rgba(63, 66, 66, 0.76)", whiteSpace: "pre-line" }}>           
              <>
                <Stack spacing={2} direction="row" sx={{marginBottom: 2, marginTop: 2}}>
                  <TextField
                    type="text"
                    variant='outlined'
                    color='secondary'
                    label="Tic #"
                    disabled={true}
                    value={ticData?.ticNumber}
                    sx={{width: 100}} 
                    size="small"
                    InputLabelProps={{shrink: true}}
                  />

                  <TextField
                    type="text"
                    variant='outlined'
                    color='secondary'
                    label="Title"
                    disabled={true}
                    value={ticData?.title}
                    sx={{width: 600}} 
                    size="small"
                    InputLabelProps={{shrink: true}}
                  />            

                  <TextField
                    type="text"
                    variant='outlined'
                    color='secondary'
                    label="Create Date"
                    disabled={true}
                    value={ticData?.createdDate}
                    sx={{width: 100}} 
                    size="small"
                    InputLabelProps={{shrink: true}}
                  />          
                </Stack>

                <Stack spacing={2} direction="row" sx={{marginBottom: 2, marginTop: 2}}>
                  <TextField
                    type="text"
                    variant='outlined'
                    color='secondary'
                    label="Park Name"
                    disabled={true}
                    value={ticData?.getParkName}
                    sx={{width: 500}} 
                    size="small"
                    InputLabelProps={{shrink: true}}
                  />            

                  <TextField
                    type="text"
                    variant='outlined'
                    color='secondary'
                    label="Park Code"
                    disabled={true}
                    value={ticData?.parkCode}
                    sx={{width: 200}} 
                    size="small"
                    InputLabelProps={{shrink: true}}
                  />         

                  <TextField
                    type="text"
                    variant='outlined'
                    color='secondary'
                    label="PMIS"
                    disabled={true}
                    value={ticData?.pmisNumber}
                    sx={{width: 100}} 
                    size="small"
                    InputLabelProps={{shrink: true}}
                  />            
                </Stack>

                <TextField
                  type="text"
                  variant='outlined'
                  color='secondary'
                  label="Requestor"
                  disabled={true}
                  value={ticData?.requestor}
                  sx={{width: 420}} 
                  size="small"
                  InputLabelProps={{shrink: true}}
                />

                <h2>Update Change Requestor</h2>

                <Autocomplete
                  id="users"
                  options={users}
                  getOptionLabel={(option) => optionLabel(option.lastName, option.firstName, option.userId)}
                  value={form?.user}
                  sx={{width: 500}} 
                  size="small"
                  onChange={(e, newValue) => {handleChange(newValue)}}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant="standard"
                      label="Change Requestor"
                      placeholder="Select A User"
                    />
                  )}
                />
                  {/* <TextField
                    type="text"
                    variant='outlined'
                    color='primary'
                    label="Change Requestor"
                    onChange={e => handleChange(e.target.value)}
                    value={form?.requestor}
                    sx={{width: 500}} 
                    size="small"
                    required
                    select>
                    {users.map((user) => (
                      <MenuItem key={user.userId} value={user?.userId}>
                        {user?.lastName + ', ' + user?.firstName}
                      </MenuItem>
                    ))}
                  </TextField> */}
              </>         
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            id="secondary" 
            variant="outlined" 
            startIcon={<FontAwesomeIcon icon={["fas", "circle-x"]} />}
            onClick={handleCloseClick}>
              Cancel
          </Button>

          <Button
            id="secondary" 
            variant="outlined" 
            startIcon={<FontAwesomeIcon icon={["fas", "save"]} />}
            disabled={!form?.requestor}
            onClick={(e) => handleSaveClick(form?.requestor, ticData)}>
              Save
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
